export { DEVICE_ID_COOKIE, getOrCreateDeviceId } from './device-id'
export {
  FIRST_TOUCH_COOKIE,
  getOrCaptureFirstTouch,
  readStoredFirstTouch,
  type FirstTouch,
} from './first-touch'
export {
  PIXEL_ADVANCED_MATCHING_KEY,
  currentPixelAdvancedMatching,
  hashEmail,
  isPixelAdvancedMatching,
  syncAnalyticsIdentity,
  type AnalyticsIdentityUser,
  type PixelAdvancedMatching,
} from './analytics-identity'
// `./analytics-identity-sync` is deliberately NOT re-exported. It imports
// `features/auth/auth-storage`, which imports this barrel for the device id —
// re-exporting the component here would close that loop into an import cycle.
// Import it by path (the root layout does).
